// One place for the details that appear in metadata, policy pages and the
// footer, so the site's name and contact address cannot drift apart again.
export const SITE_NAME = "LottoNest";
export const SITE_URL = "https://www.lottonest.com";

// Must be a mailbox that is actually monitored: ad networks and users both
// expect a reachable contact.
export const CONTACT_EMAIL = "contact@lottonest.com";

export const ADSENSE_CLIENT = "ca-pub-4713365631308072";

// Kept in one place so the policy pages can state a real date.
export const POLICY_UPDATED = "16 August 2026";
